import React from 'react';
import PropTypes from 'prop-types';

/**
 * Decorative header ring. Size/colour/stroke stay as props so the three
 * brand ellipses can share one SVG instead of three hardcoded files.
 */
const HeaderRing = ({
  size = 47.289,
  color = '#48a9a6',
  strokeWidth = 7,
  ...props
}) => {
  const inset = strokeWidth / 2;
  const r = (size - strokeWidth) / 2;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <circle
        cx={r}
        cy={r}
        r={r}
        transform={`translate(${inset} ${inset})`}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

HeaderRing.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export default HeaderRing;
